module.exports = __webpack_public_path__ + "img/bg-404.3b264054.jpg";